import React from 'react';
import PageTemplate from '../components/PageTemplate';
import ContactComponent from '../components/Contact';

const Contact = () => {
  return (
    <PageTemplate
      title="Contact Us"
      subtitle="Get in touch with our team to discuss your project"
      breadcrumb="Contact"
    >
      <div className="content-section">
        <div className="two-column">
          <div>
            <h3>Let's Start a Conversation</h3>
            <p>Ready to transform your business with cutting-edge technology? Our team is here to help you navigate your digital transformation journey.</p>
            
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <h4>Address</h4>
                  <p>97 Blenheim Road, Bolton, England, BL2 6EL</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <div>
                  <h4>Phone</h4>
                  <p>+447586094540</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <h4>Email</h4>
                  <p>info@codes-ai.com</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-clock"></i>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9:00 AM - 6:00 PM GMT</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="contact-form">
              <h3>Send us a Message</h3>
              <form>
                <div className="form-group">
                  <input type="text" placeholder="Your Name" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Your Email" required />
                </div>
                <div className="form-group">
                  <input type="text" placeholder="Subject" required />
                </div>
                <div className="form-group">
                  <textarea placeholder="Your Message" rows="5" required></textarea>
                </div>
                <button type="submit" className="btn btn-primary">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      <ContactComponent />
    </PageTemplate>
  );
};

export default Contact; 